export default {
  setTransactionName(sentry, name) {
    const transaction  = name.split('/');
    transaction.pop();
    transaction.shift();
    const transactionName = transaction.join('/');
    sentry.configureScope(scope => scope.setTransactionName(`/${transactionName}`));
  }
};
